<script setup>
const { $localApi } = useNuxtApp();

const props = defineProps({
  artists: { type: Array, required: true, default: () => [{}] },
  meetingCreator: { type: Object, default: null },
  ceek: { type: Number, default: 1 },
});

const allCreators = computed(() => {
  if (props.meetingCreator) {
    return [...props.artists, props.meetingCreator];
  }

  return props.artists;
});

const $emit = defineEmits(['close']);

const donationProgress = ref(null);
const selectedArtists = ref([]);

async function sendCeekReward(event) {
  event.preventDefault();

  donationProgress.value = 'PROCESSING';

  const payload = {
    amount: props.ceek,
    artistsIds: [...selectedArtists.value],
  };

  // check if meeting creator exist and included to array
  if (props.meetingCreator && selectedArtists.value.includes(props.meetingCreator.id)) {
    payload.artistsIds = payload.artistsIds.filter((id) => id !== props.meetingCreator.id);

    payload.meetingCreatorId = props.meetingCreator.id;
  }

  const { data, error } = await $localApi.post('/content/player/donate', {
    body: payload,
  });

  if (error.value || data.value?.error) {
    $emit('close');

    return;
  }

  donationProgress.value = 'SUCCESS';
}

function closeModal() {
  $emit('close');

  setTimeout(() => {
    donationProgress.value = null;
  }, 300);
}
</script>

<template>
  <MoleculeModalBase @close="$emit('close')">
    <template #content>
      <template v-if="!donationProgress">
        <div class="text-center text-xl dark:text-white">
          I would like to send
          <span
            class="bg-[linear-gradient(90deg,#965ef6,#ff43ac_150%)] bg-clip-text text-transparent"
            >{{ ceek }} CEEK REWARD</span
          >
          to see more content from
        </div>

        <div class="my-4 flex flex-wrap justify-center gap-12 text-xl">
          <div
            v-for="artist in allCreators"
            :key="artist.id"
            class="flex cursor-pointer items-center gap-2"
          >
            <input
              :id="artist.name"
              v-model="selectedArtists"
              :value="artist.id"
              :name="artist.name"
              type="checkbox"
              class="size-6 cursor-pointer rounded border bg-transparent accent-pink-500"
              @click.stop
            />
            <label :for="artist.name" class="cursor-pointer dark:text-white">{{
              artist.name || 'this user'
            }}</label>
          </div>
        </div>

        <div class="mt-4 grid grid-cols-1 gap-5 md:grid-cols-2">
          <button
            type="button"
            class="rounded-xl border-2 px-2 py-3 text-lg capitalize text-black transition-all hover:bg-white hover:text-blue-700 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-white/50 disabled:opacity-50 dark:text-white dark:hover:text-black"
            :disabled="!selectedArtists.length"
            @click="sendCeekReward"
          >
            CONFIRM
          </button>
          <button
            type="button"
            class="rounded-xl border-2 px-2 py-3 text-lg capitalize text-black transition-all hover:bg-white hover:text-blue-700 dark:text-white dark:hover:text-black"
            @click="closeModal"
          >
            CANCEL
          </button>
        </div>
      </template>
      <template v-else>
        <template v-if="donationProgress === 'PROCESSING'">
          <div class="text-center text-xl dark:text-white">
            TRANSACTION IN PROGRESS
            <p>Do not refresh page.</p>
          </div>
          <div class="group-center grid">
            <AtomLoaderCircle class="mx-auto my-2 w-20" />
          </div>
        </template>
        <template v-if="donationProgress === 'SUCCESS'">
          <div class="text-center text-xl dark:text-white">
            Transaction is in progress. Message will be sent to your email address after transaction
            is completed. You can follow the transaction status on My Transaction page.
          </div>
          <div class="group-center mt-4 grid">
            <button
              type="button"
              class="mx-auto w-64 rounded-xl border-2 px-2 py-3 text-lg capitalize text-black transition-all hover:bg-white hover:text-blue-700 dark:text-white dark:hover:text-black"
              @click="closeModal"
            >
              CONFIRM
            </button>
          </div>
        </template>
      </template>
    </template>
  </MoleculeModalBase>
</template>
